module.exports = __webpack_public_path__ + "img/beer.ace0220e.jpg";